// "I Took My Code RAG From 75% to 90%" — the 10-fix masterclass short.
// Cold Compute / Neon kit. ~134s @ 30fps.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; contiguous (next.start = prev.start + prev.duration).
export const SCENE = {
  hook: { start: 0, duration: 150 }, //        0:00–0:05  fabricated code flow
  symptom: { start: 150, duration: 480 }, //   0:05–0:21  75% fabricated an architecture
  diagnosis: { start: 630, duration: 480 }, // 0:21–0:37  BM25 returned 0 rows for weeks
  fix1: { start: 1110, duration: 510 }, //     0:37–0:54  mig 033 OR-tsquery → 0→15–20
  plateau: { start: 1620, duration: 390 }, //  0:54–1:07  stuck at 85% ceiling
  fix2: { start: 2010, duration: 660 }, //     1:07–1:29  mig 034 camelCase split (the SQL)
  compose: { start: 2670, duration: 480 }, //  1:29–1:45  10 fixes, 11→16 steps
  payoff: { start: 3150, duration: 570 }, //   1:45–2:04  ~75% → peak 90%
  outro: { start: 3720, duration: 300 }, //    2:04–2:14
} as const;

export const TOTAL_DURATION = 4020; // 134s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
